export default "__VITE_ASSET__DgNb59Lb__"